<template>
  <base-content :data="data"
    :index="index">
      <template #card-header>
        <partial-title
          :title="title"
          :link="link"
          :lineClamp="3"
        />
      </template>

      <template #card-body>
        <ul>
          <li class="mb-2 t-sm d-flex justify-content-between">
            <span>{{ publicationDate }}</span>
            <span class="t-600">{{ publicationDateFromNow }}</span>
          </li>
          <li v-if="summary" class="t-sm t-semi-compact mb-2" v-line-clamp="4" v-html="summary" />

          <li class="d-flex mb-2"
            v-if="!isEmpty(data.industries)"
          >
            <keywords
              :keywords="data.industries"
              :limit="3"
              :property="''"
              hideShowAll
            />
          </li>

          <matches class="mt-2" v-if="!isEmpty(matches)" :matches="matches" />
        </ul>
      </template>
      <template #card-footer>
        <partial-organisations v-if="!isEmpty(data.organisations)"
          :organisations="data.organisations"
          :lineClamp="1"
          hideFlags
        />
        <li class="row-content" v-if="country || locationString">
          <span class="row-content--side">
            <flag :title="renderCountryFlagTooltip(country)" v-if="country" :iso="country.alpha_2 | lowercase" :squared="false" class="bd-radius mr-2 flag-positioning" />
          </span>
          <span class="row-content--main t-overflow">
            {{ locationString }}
          </span>
        </li>
      </template>
      <template #card-actions>
        <slot name="actions"></slot>
      </template>
  </base-content>
</template>

<script>
import processing from '@/mixins/search/results/news'

import BaseContent from '@/components/search/results/BaseContent'
import Matches from '@/components/search/results/partials/Matches'
import PartialTitle from '@/components/search/results/partials/Title'
import Keywords from '@/components/shared/Keywords'
import PartialOrganisations from '@/components/search/results/partials/Organisations'

export default {
  name: 'newsResultBlock',
  mixins: [processing],
  components: {
    Matches,
    PartialTitle,
    BaseContent,
    Keywords,
    PartialOrganisations
  }
}
</script>
